import {
  useMediaQuery,
  useTheme,
  Box,
} from '@mui/material';
import PropTypes from 'prop-types';
import {
  TypographyElement,
  useContentElement,
  useContentVisibility,
  VisibilityScheme,
} from '@plugins/next-cms-core';
import defaults from 'lodash/defaults';
import isNull from 'lodash/isNull';
import omitBy from 'lodash/omitBy';
import CarSearchFilterBar from '../organisms/CarSearchFilterBar';
import Container from '../atoms/Container';

export default function CarSearchFilterBlock(props) {
  const { data } = props;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { elementData } = useContentElement(
    data,
    CarSearchFilterBlock.dataSchema,
  );

  const {
    brand,
    isTranslatedY,
    branch,
    visibility,
  } = elementData;

  const title = omitBy(elementData.title, isNull);
  defaults(title, {
    semanticVariant: 'h3',
    displayVariant: 'h3',
  });

  const subtitle = omitBy(elementData.subtitle, isNull);
  defaults(subtitle, {
    semanticVariant: 'h4',
    displayVariant: 'subtitle1',
  });

  const rootStyles = useContentVisibility(visibility);

  return (
    <Box sx={rootStyles}>
      <Container>
        <CarSearchFilterBar
          isMobile={isMobile}
          preSelectedBranch={branch?.data?.id}
          preSelectedBrand={brand}
          subtitle={subtitle}
          title={title}
          translateY={isMobile ? false : isTranslatedY}
        />
      </Container>
    </Box>
  );
}

CarSearchFilterBlock.typeName = 'ComponentContentCarSearchFilter'; // Strapi element type
CarSearchFilterBlock.propTypes = {
  data: PropTypes.shape({
    isTranslatedY: PropTypes.bool,
    visibility: VisibilityScheme.propTypes,
  }).isRequired,
};

CarSearchFilterBlock.graphQlSchema = `
... on ${CarSearchFilterBlock.typeName} {
  id
  brand
  isTranslatedY
  branch {
    data {
      id
    }
  }
  title {
    ${TypographyElement.graphQlSchema}
  }
  subtitle {
    ${TypographyElement.graphQlSchema}
  }
  visibility {
    ${VisibilityScheme.graphQlSchema}
  }
}
`;
